<template>
<div id="purchases">
  <h3>Purchases</h3>

  <paged-purchases
    :resourceUrl="this.apiUrl('/users/' + userId + '/purchases')"
    :formdata="formdata"
  />

</div>
</template>

<script>
import PurchasesPaged from '@/components/PurchasesPaged'

export default {
  components: {
    'paged-purchases': PurchasesPaged
  },

  computed: {
    formdata () {
      return {
        statuses: ['all']
      }
    }
  },

  props: ['userId'],

  methods: {
    formatDate (d) {
      return this.$root.displayDateTimeFmt(d)
    },

    onPageSuccess (response) {
      this.purchases = this.processSuccess(response)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserPurchases.vue